<template>
    <div class="block-edit">
        <div class="row">
            <div class="col-md-12">
                <p>Name: {{block.name.text}}<br>
                    Typ: {{block.class}}<br>
                    ID: {{block.id}}
                </p>
                <p>Erstellt: {{block.createdAt.date}}<br>
                    Aktualisiert: {{block.updatedAt.date}}<br>
                    Aktuelle Version: {{versions[block.editVersion]}}
                </p>
                <p>
                    <a
                            :href="portalBaseUrl + '/' + store.state.language + '/block-preview/' + block.id"
                            target="_blank"><i class="fa fa-share"></i> Live Vorschau</a>
                </p>
                <div class="form-group">
                    <label>Neue Version</label>
                    <multiselect v-model="editVersion"
                                 placeholder="Version" :options="options"
                                 track-by="id" :allow-empty="false" label="name">
                        <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                    </multiselect>
                </div>
                <div class="form-group">
                    <a href="#" @click.prevent="changeVersion" class="btn btn-primary">Neue Version erstellen</a>
                </div>
            </div>
            <div class="col-md-12">
                <h3>Alte Versionen</h3>
                <ul>
                    <li v-for="backupVersion in block.backupVersions">ID {{backupVersion.id}}<br>
                        Datum: {{backupVersion.updatedAt.date}}<br>
                        Version: {{versions[backupVersion.editVersion]}}<br>
                        <small><a
                                :href="portalBaseUrl + '/' + store.state.language + '/block-preview/' + backupVersion.id"
                                target="_blank"><i class="fa fa-share"></i> Vorschau</a>
                            <a href=""
                               v-confirm="{
                            html: true,
                            ok: dialog => deleteBackupVersion(backupVersion.id),
                            message: 'Bist du sicher, dass du die Version <strong>'+backupVersion.id+'</strong> löschen möchtest?'}"><i
                                    class="fa fa-trash"></i> Löschen</a></small>
                    </li>
                </ul>
                <hr>
                <div class="form-group">
                    <label>Momentan online</label>
                    <multiselect v-model="currentVersion"
                                 placeholder="Momentan online" :options="currentVersionOptions"
                                 track-by="id" :allow-empty="false" label="name">
                        <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                    </multiselect>
                </div>
                <div class="form-group">
                    <a href="#" class="btn btn-primary" @click.prevent="changeCurrentVersion">Andere Version online
                        stellen</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  props: ["blockData"],
  data() {
    let versions = {
      1: "Original",
      2: "Erster Entwurf",
      3: "Zweiter Entwurf",
      4: "Finalisiert",
      5: "Übersetzt",
      9: "Online"
    };
    return {
      block: this.blockData,
      versions: versions,
      editVersion: {
        id: this.blockData.editVersion,
        name: versions[this.blockData.editVersion]
      },
      currentVersion: {
        id: this.blockData.currentVersionId,
        name:
          this.blockData.currentVersionId == 0
            ? "Offline"
            : this.blockData.currentVersionId
      },
      options: [
        { name: versions[1], id: 1 },
        { name: versions[2], id: 2 },
        { name: versions[3], id: 3 },
        { name: versions[4], id: 4 },
        { name: versions[5], id: 5 },
        { name: versions[9], id: 9 }
      ]
    };
  },
  computed: {
    currentVersionOptions: function() {
      let r = [{ name: "Offline", id: 0 }];
      for (let backupVersion of this.block.backupVersions) {
        r.push({ name: backupVersion.id, id: backupVersion.id });
      }
      return r;
    },
    store: function() {
      return store;
    },
    portalBaseUrl: function() {
      return portalBaseUrl;
    }
  },
  methods: {
    changeVersion() {
      let form = new FormData();
      form.append("change_version[version]", this.editVersion.id);
      store.commit("addSavingProcess");

      axios
        .post(
          "/api/" +
            store.state.language +
            "/block/" +
            this.blockData.id +
            "/change_version",
          form
        )
        .then(({ data }) => {
          store.commit("finishSavingProcess");
          this.block = data.result;
          this.$emit("saved", this.value);
        });
    },
    changeCurrentVersion() {
      store.commit("addSavingProcess");

      axios
        .post(
          "/api/" +
            store.state.language +
            "/block/" +
            this.blockData.id +
            "/change_current_version",
          { id: this.currentVersion.id }
        )
        .then(({ data }) => {
          store.commit("finishSavingProcess");
          this.$emit("saved", this.value);
        });
    },
    deleteBackupVersion(id) {
      store.commit("addSavingProcess");

      axios
        .post(
          "/api/" +
            store.state.language +
            "/block/" +
            this.blockData.id +
            "/delete_backup_version",
          { id: id }
        )
        .then(({ data }) => {
          store.commit("finishSavingProcess");
          this.block = data.result;
          this.$emit("saved", this.value);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Blocks/GeneralBlock.vue